

document.addEventListener("DOMContentLoaded", function () {
  const containerSelector = '.variant-picker__option-values';

  function refreshActive(container) {
    let selectedPrice = '';

    container.querySelectorAll('.option_wrapper').forEach(wrapper => {
      wrapper.classList.remove('active');
      const radio = wrapper.querySelector('input[type="radio"]');
      if (radio && radio.checked) {
        wrapper.classList.add('active');
        selectedPrice = wrapper.getAttribute('data-variant-price') || '';
      }
    });

    const priceElement = document.querySelector('.show_price');
    if (priceElement && selectedPrice) {
     priceElement.innerHTML = `<span class="money">${selectedPrice}</span>`;
    }
     const priceOneTime = document.querySelector('.rc-option__price.rc_widget__price--onetime');
    if (priceOneTime && selectedPrice) {
     priceOneTime.innerHTML = selectedPrice;
    }




const priceSubSave = document.querySelector('.rc-option__price.rc_widget__price--subsave');

function parseNumericFragment(raw) {
    // Normalize common group separators: apostrophe and spaces
    raw = raw.replace(/'/g, '').replace(/\s+/g, '');
    // If contains both dot and comma, decide which is decimal by position
    const lastDot = raw.lastIndexOf('.');
    const lastComma = raw.lastIndexOf(',');
    let cleaned = raw;

    if (lastComma > -1 && lastDot > -1) {
        // If comma comes after dot, comma is decimal separator (European style)
        if (lastComma > lastDot) {
            cleaned = raw.replace(/\./g, '').replace(',', '.');
        } else {
            // dot is decimal, remove commas
            cleaned = raw.replace(/,/g, '');
        }
    } else if (raw.includes(',')) {
        // Only commas present: decide if comma is decimal (e.g. "12,50") or thousands ("1,299")
        const parts = raw.split(',');
        const lastPart = parts[parts.length - 1];
        if (lastPart.length === 2) {
            // likely decimal cents "12,50" -> "12.50"
            cleaned = raw.replace(/,/g, '.');
        } else {
            // likely thousand separators -> remove them
            cleaned = raw.replace(/,/g, '');
        }
    } else {
        // no comma, maybe only dots; remove thousands separators if any (rare) else keep dot as decimal
        // keep as-is, but also remove stray thousands like "12.900.00" (two dots)
        const dotCount = (raw.match(/\./g) || []).length;
        if (dotCount > 1) {
            // assume dots used as thousands and one decimal - remove all dots except last as decimal
            const last = raw.substring(raw.lastIndexOf('.'));
            cleaned = raw.replace(/\./g, '').replace(last.replace('.', ''), last);
        } else {
            cleaned = raw;
        }
    }

    // Final cleanup: remove any non-digit/decimal char left
    cleaned = cleaned.replace(/[^0-9.]+/g, '');

    const value = parseFloat(cleaned);
    return isNaN(value) ? null : value;
}

function discount15FromString(str, options = { keepCurrency: false, formatWithThousands: false }) {
    if (!str || typeof str !== 'string') return null;

    // Find all numeric-like fragments
    const fragments = str.match(/[\d][0-9\.,'\s]*/g) || []; // find sequences starting with digit
    const parsed = [];

    for (const frag of fragments) {
        const v = parseNumericFragment(frag);
        if (v !== null) parsed.push({ raw: frag.trim(), value: v });
    }

    if (parsed.length === 0) {
        console.log('No numeric fragments found in:', str);
        return null;
    }

    // Choose the best candidate:
    // prefer the largest number > 1 (prices are usually >1). If none >1, choose the max
    let candidates = parsed.filter(p => p.value > 1);
    let chosen = (candidates.length ? candidates : parsed).reduce((a, b) => (a.value >= b.value ? a : b));

    console.log('Found numeric fragments:', parsed);
    console.log('Chosen fragment to discount:', chosen);

    // Apply discount
    const discountedValue = +(chosen.value * 0.85).toFixed(2);

    // Format discounted number optionally with thousands separators
    let discountedStr;
    if (options.formatWithThousands) {
        // Use user's locale by default (if unavailable will fallback)
        discountedStr = discountedValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
        discountedStr = discountedValue.toFixed(2);
    }

    if (options.keepCurrency) {
        // Replace only the chosen.raw inside the original string with the discounted string
        // Use first exact occurrence (trim spaces for safety)
        const re = new RegExp(chosen.raw.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'));
        return str.replace(re, discountedStr);
    }

    // Default: return only the discounted number
    return discountedStr;
}

// USAGE
if (priceSubSave && selectedPrice) {
    // DEBUG: try both modes
    const discountedOnly = discount15FromString(selectedPrice, { keepCurrency: false, formatWithThousands: false });
    const discountedWithCurrency = discount15FromString(selectedPrice, { keepCurrency: true, formatWithThousands: true });

    console.log('discountedOnly:', discountedOnly);
    console.log('discountedWithCurrency:', discountedWithCurrency);

    // Choose what you want displayed:
    // priceSubSave.innerHTML = discountedOnly;               // Just number: "10965.00"
    priceSubSave.innerHTML = discountedWithCurrency || discountedOnly || ''; // Keep currency and formatting if possible
}






  }

  // Delegated click handler
  document.body.addEventListener('click', function (e) {
    const wrapper = e.target.closest('.option_wrapper');
    if (!wrapper) return;

    const container = wrapper.closest(containerSelector);
    if (!container) return;

    const radio = wrapper.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      refreshActive(container);
    }
  });

  // Delegated change handler (after Shopify JS runs)
  document.body.addEventListener('change', function (e) {
    if (e.target.matches(containerSelector + ' input[type="radio"]')) {
      const container = e.target.closest(containerSelector);
      if (container) refreshActive(container);
    }
  });

  // Initial refresh for pre-checked option
  document.querySelectorAll(containerSelector).forEach(refreshActive);
});







document.addEventListener("DOMContentLoaded", () => {
  // Function to check and add class
  function checkAndAddClass() {
    document.querySelectorAll('.buy_wrapper').forEach(wrapper => {
      if (wrapper.classList.contains('has-rc-container')) return;
      const form = wrapper.querySelector('form');
      if (!form) return;
      if (form.querySelector('.rc-container-wrapper.rc_container_wrapper')) {
        wrapper.classList.add('has-rc-container');
        console.log('Class added to', wrapper);
      }
    });
  }

  // Run once on page load
  checkAndAddClass();

  // Observe for future DOM changes (e.g., Recharge box injection)
  const observer = new MutationObserver(() => {
    checkAndAddClass();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});








document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector("footer");
  if (!footer) return;

  function checkStickyBar() {
    const stickyBar = document.querySelector(".product-sticky-bar.is-visible");

    if (stickyBar) {
      footer.classList.add("has-sticky-bar");

      // If sticky bar has subscription class
      if (stickyBar.classList.contains("has-rc-container")) {
        footer.classList.add("has-rc-container");
      } else {
        footer.classList.remove("has-rc-container");
      }
    } else {
      footer.classList.remove("has-sticky-bar", "has-rc-container");
    }
  }

  // Run once on load
  checkStickyBar();

  // Watch for changes in the DOM
  const observer = new MutationObserver(checkStickyBar);
  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector("footer");
  const stickyBar = document.querySelector("product-sticky-bar"); // tag selector

  if (!footer || !stickyBar) return;

  function adjustFooterMargin() {
    if (stickyBar.classList.contains("is-visible")) {
      footer.style.marginBottom = stickyBar.offsetHeight + "px";
    } else {
      footer.style.marginBottom = "";
    }
  }

  // Initial run
  adjustFooterMargin();

  // Update on window resize
  window.addEventListener("resize", adjustFooterMargin);

  // Watch for class/style changes
  new MutationObserver(adjustFooterMargin).observe(stickyBar, {
    attributes: true,
    attributeFilter: ["class", "style"]
  });

  // Watch for height/content changes (dynamic subscription etc.)
  if ("ResizeObserver" in window) {
    new ResizeObserver(adjustFooterMargin).observe(stickyBar);
  }
});



document.addEventListener('DOMContentLoaded', function () {
  const cartIcon = document.querySelector('.header__cart-icon-wrapper');
  const cartDrawer = document.querySelector('cart-drawer');
  const cartClose = cartDrawer?.querySelector('.cart-drawer__close');

  if (cartIcon && cartDrawer) {
    // Open cart drawer
    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      cartDrawer.classList.add('is-open'); // Add your active class
      document.body.classList.add('drawer-open'); // Optional: lock scroll
    });

    // Close cart drawer
    if (cartClose) {
      cartClose.addEventListener('click', (e) => {
        e.preventDefault();
        cartDrawer.classList.remove('is-open');
        document.body.classList.remove('drawer-open');
      });
    }

    // Optional: close when clicking outside
    document.addEventListener('click', (e) => {
      if (
        !e.target.closest('cart-drawer') &&
        !e.target.closest('.header__cart-icon-wrapper')
      ) {
        cartDrawer.classList.remove('is-open');
        document.body.classList.remove('drawer-open');
      }
    });
  }
});




function checkReChargeOptions() {
  const parentWrapper = document.querySelector('.buy_wrapper.has-rc-container');
  const legacyRadio = document.querySelector('.rc-template__legacy-radio');

  if (!parentWrapper || !legacyRadio) {
    return;
  }

  const radioOptions = legacyRadio.querySelectorAll('.rc-radio');

  if (radioOptions.length >= 2) {
    parentWrapper.classList.add('has-two-radios');
    clearInterval(checkInterval); // stop checking once done
  }
}

const checkInterval = setInterval(checkReChargeOptions, 500); // runs until found



document.addEventListener("DOMContentLoaded", function () {
  for (const sheet of document.styleSheets) {
    let rules;
    try {
      rules = sheet.cssRules;
    } catch (e) {
      continue; // Skip cross-origin styles (Shopify CDN)
    }

    for (const rule of rules) {
      if (!(rule instanceof CSSStyleRule)) continue;

    // Skip product-card and custom-card completely
        if (
          rule.selectorText &&
          (rule.selectorText.includes(".product-card") ||
          rule.selectorText.includes(".custom-card"))
        ) {
          continue;
        }


      const style = rule.style;

      // Replace background-color #fff
      if (
        style.backgroundColor === "rgb(255, 255, 255)" ||
        style.backgroundColor === "#fff" ||
        style.backgroundColor === "#ffffff"
      ) {
        style.backgroundColor = "#f6f7f2";
      }

      // Replace background #fff
      if (
        style.background === "rgb(255, 255, 255)" ||
        style.background === "#fff" ||
        style.background === "#ffffff"
      ) {
        style.background = "#f6f7f2";
      }
    }
  }
});








// products slider js

document.addEventListener('DOMContentLoaded', function () {
    const swiperWrappers = document.querySelectorAll('.product_tabs .tab_slider_wrapper');

    swiperWrappers.forEach(function (swiperEl) {

        const track = swiperEl.querySelector('.swiper-wrapper');
        let isScrolling = false;
        let isDragging = false;
        let startX = 0;
        const dragThreshold = 50;

        let ugcSwiper;

        function initSwiper() {
            ugcSwiper = new Swiper(swiperEl, {
                slidesPerView: 4,
                spaceBetween: 20,
                loop: true,
                speed: 500,
                navigation: {
                    nextEl: swiperEl.querySelector('.swiper-button-next'),
                    prevEl: swiperEl.querySelector('.swiper-button-prev'),
                },
                keyboard: {
                    enabled: true,
                },
                breakpoints: {
                    0: { slidesPerView: 1, spaceBetween: 16 },
                    601: { slidesPerView: 2, spaceBetween: 20 },
                    1025: { slidesPerView: 3, spaceBetween: 20 },
                    1441: { slidesPerView: 4, spaceBetween: 20 }
                },
                on: {
                    init: equalizeSlideHeights,
                    resize: equalizeSlideHeights
                }
            });

            // === Horizontal Scroll with Mouse Wheel ===
            swiperEl.addEventListener(
                'wheel',
                function (e) {
                    const shouldScroll =
                        Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.shiftKey;

                    if (!shouldScroll) return;

                    e.preventDefault();
                    if (isScrolling) return;
                    isScrolling = true;

                    if (e.deltaX > 0 || e.deltaY > 0) {
                        ugcSwiper.slideNext();
                    } else {
                        ugcSwiper.slidePrev();
                    }

                    setTimeout(() => (isScrolling = false), 500);
                },
                { passive: false }
            );

            // === Drag Support ===
            function getX(e) {
                return e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
            }

            function dragStart(e) {
                isDragging = true;
                startX = getX(e);
                track.classList.add('dragging');
            }

            function dragEnd(e) {
                if (!isDragging) return;
                isDragging = false;
                track.classList.remove('dragging');

                const endX = getX(e);
                const delta = endX - startX;

                if (Math.abs(delta) > dragThreshold) {
                    delta > 0 ? ugcSwiper.slidePrev() : ugcSwiper.slideNext();
                }
            }

            track.addEventListener('mousedown', dragStart);
            track.addEventListener('mouseup', dragEnd);
            track.addEventListener('mouseleave', dragEnd);

            track.addEventListener('touchstart', dragStart);
            track.addEventListener('touchend', dragEnd);
        }

        function equalizeSlideHeights() {
            const slides = swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
            let maxHeight = 0;

            slides.forEach(slide => {
                slide.style.height = 'auto';
                maxHeight = Math.max(maxHeight, slide.offsetHeight);
            });

            slides.forEach(slide => {
                slide.style.height = maxHeight + 'px';
            });
        }

        if (typeof Swiper !== 'undefined') {
            initSwiper();
        } else {
            window.addEventListener('load', initSwiper);
        }
    });
});




document.addEventListener("DOMContentLoaded", function () {
  // IMG — use alt as title
  document.querySelectorAll("img").forEach(img => {
    let altText = img.getAttribute("alt");
    if (altText && altText.trim() !== "") {
      img.setAttribute("title", altText.trim());
    }
  });

  // SVG (inline) — use aria-label, title tag, or data-alt
  document.querySelectorAll("svg").forEach(svg => {
    let altText =
      svg.getAttribute("aria-label") ||
      svg.getAttribute("data-alt") ||
      (svg.querySelector("title") && svg.querySelector("title").textContent);

    if (altText && altText.trim() !== "") {
      svg.setAttribute("title", altText.trim());
    }
  });

  // <use> icons inside SVG sprites
  document.querySelectorAll("use").forEach(use => {
    let altText =
      use.getAttribute("aria-label") ||
      use.getAttribute("data-alt") ||
      use.getAttribute("alt");

    if (altText && altText.trim() !== "") {
      use.setAttribute("title", altText.trim());
    }
  });

  // ANY element with aria-label or data-alt → set title
  document.querySelectorAll("[aria-label], [data-alt]").forEach(el => {
    let text = el.getAttribute("aria-label") || el.getAttribute("data-alt");
    if (text && text.trim() !== "") {
      el.setAttribute("title", text.trim());
    }
  });
});
